// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEffect } from "effector";
import {
  ThematicDossierInfoResponseDTO,
  ThematicDossierPatchDTO,
  ThematicDossierWriteRequestDTO
} from "../../api/backend-openapi";
import "whatwg-fetch";
import configuration from "../../utils/Config";
import {
  restCreationHandler,
  restDecreaseOrderHandler,
  restDeletionHandler,
  restDetailsHandler,
  restFieldUpdateHandler,
  restIncreaseOrderHandler,
  restListHandler,
  restUnpublishHandler,
  restUpdateHandler
} from "../../utils/rest/RestClient";

const baseUrl = configuration.backendBaseUrl;
const newsUrl = baseUrl + "/thematicDossiers/";

export const requestGetThematicDossiers = createEffect({
  handler: restListHandler<ThematicDossierInfoResponseDTO>(newsUrl)
});
export const requestGetThematicDossier = createEffect({
  handler: restDetailsHandler<ThematicDossierInfoResponseDTO>(newsUrl)
});
export const requestCreateThematicDossier = createEffect({
  handler: restCreationHandler<
    ThematicDossierWriteRequestDTO,
    ThematicDossierInfoResponseDTO
  >(newsUrl)
});
export const requestUpdateThematicDossier = createEffect({
  handler: restUpdateHandler<
    ThematicDossierWriteRequestDTO,
    ThematicDossierInfoResponseDTO
  >(newsUrl)
});
export const requestUnpublishThematicDossier = createEffect({
  handler: restUnpublishHandler<
    { published: boolean },
    ThematicDossierInfoResponseDTO
  >(newsUrl)
});
export const requestDeleteThematicDossier = createEffect({
  handler: restDeletionHandler<ThematicDossierInfoResponseDTO>(newsUrl)
});
export const requestWorkflowThematicDossier = createEffect({
  handler: restFieldUpdateHandler<
    ThematicDossierPatchDTO,
    ThematicDossierInfoResponseDTO
  >(newsUrl)
});
export const requestIncreaseOrderThematicDossier = createEffect({
  handler: restIncreaseOrderHandler<ThematicDossierInfoResponseDTO>(newsUrl)
});
export const requestDecreaseOrderThematicDossier = createEffect({
  handler: restDecreaseOrderHandler<ThematicDossierInfoResponseDTO>(newsUrl)
});
